import { SET_CURRENT_CUSTOMER_ID, SET_LOGGEDIN_USER_ID, TIMER, ADD_LISTENER, DATA_ADDED, DATA_MODIFIED, DATA_REMOVED, SET_SHORTCUTS, SET_ACTIVE_SHORTCUT, UPDATE_USER, LOAD_TODAYHAPPINESS, SET_MYHAPPINESS, SET_EMPLOYEE_HAPPINESS, UPDATE_EMPLOYEES, UPDATE_QUOTES, VALIDATING_CUSTOMER, SET_CUSTOMER, SET_OVERLAY, SET_WEATHER } from './types.js';
import { db, storage, auth, weather } from '../config/firebase';
import moment from 'moment';
import {reset} from 'redux-form';
import * as firebase from "firebase";
import {todayHappiness} from './selectors'
import { todayID, weekID, lastWeekID, daysInThisWeek } from '../components/assets/util';
import history from '../config/history';

const set = (path, val) => {
  let obj = {};
  let keys = [...path];
  const lastKey = keys.pop();
  const lastObj = keys.reduce((obj, key) =>
      obj[key] = obj[key] || {},
      obj);
  lastObj[lastKey] = val;
  return obj;
};

// Some basic changes to sync mechanism. Old interface still works, but you can do new things now.
// Examples:
//
// sync(`customers`, `people`)
// Gets all customers, and for each customer, gets all people
//
// sync(`customers`, r => r.limit(2), `people`)
// Gets the first two customers in the database, and for those customers, gets all people.
// So modifiers can still be applied
//
// sync(`customers`, r => r.limit(2), `people`, r => r.limit(5))
// Gets the first two customers in the database, and for those customers, gets the first five people.
// Modifiers can be applied to each stage individually.
//
// sync(`customers`, r => r.limit(2), `people`, 'happiness', r => r.orderBy("date", "desc").limit(2))
// Gets the first two customers in the database, all people for those customers, and the two most recent happiness entries for all those people
// You can go as many levels deep as you like, and add or omit modifiers as you please.
//
export const sync = (...args) => (dispatch, getState) => {
  let ref = typeof args[0] === 'string' && args[0];
  let mod = args.length > 1 && typeof args[1] === 'function' && args[1];

  let path = ref.split('/');
  let listener = null;

  if(path.length % 2){    // Dealing with a collection
    let dbRef = db.collection(ref);

    if(mod){
        dbRef = mod(dbRef);
    }

    listener = dbRef.onSnapshot(snapshot => {
      snapshot.docChanges().forEach(change => {
        if (change.type === "added" || change.type === "modified") {
          dispatch({type: DATA_MODIFIED, payload: set([...path, change.doc.id], change.doc.data())});
        }
        if (change.type === "removed") {
            dispatch({type: DATA_REMOVED, payload: {
              path: path.join('.'),
              id: change.doc.id
            }})
        }

        if(change.type === "added"){
          let nextIndex = mod ? 2 : 1;
          if(args.length <= nextIndex || typeof args[nextIndex] !== 'string')
            return;

          let newArgs = [`${ref}/${change.doc.id}/${args[nextIndex]}`, ...args.slice(nextIndex)];
          dispatch(sync(...newArgs));
        }
        });
      });
    }else{
      listener = db.doc(ref).onSnapshot(doc => {
        dispatch({type: DATA_MODIFIED, payload: set(path, doc.data())});
      })
    }

    dispatch({type: ADD_LISTENER, payload: {ref, listener}});
}

export const inviteEmployee = (email) => (dispatch, getState) => {
  const customerId = getState().general.company.customerId;
  db.collection('customers').doc(customerId).collection('invites').where("email", "==", email ).get()
  .then(snap => {
    if(getState().general.user.admin && snap.empty) {
      db.collection('customers').doc(customerId).collection('invites').add({email: email});
    } else { alert('This email is already added.')}
  });

}
export const register = (customerId, id, values) => (dispatch, getState) => {
  // is this person added by the company? (allowed to make an account)
  db.collection('customers').doc(customerId).collection('invites').doc(id).get()
  .then(doc => {
    if(doc.exists && doc.data().email === values.email) {
      // if person has an invite, check if they already have an authorised account
      console.log('Invite exists? ', doc.exists)
      auth.fetchSignInMethodsForEmail(values.email)
      .then(res => {
        console.log(res)
        const params = {
          email: values.email,
          nameF: values.nameF,
          nameL: values.nameL,
          enabled: true,
          loggedIn: true
        }
        if(res.length === 0) {
          // user is new
          auth.createUserWithEmailAndPassword(values.email, values.password)
          .then(res => {
            let user = firebase.auth().currentUser;
            params.uid = user.uid;
            db.collection('customers').doc(customerId).collection('people').doc(user.uid).set(params);
            // get the shortcuts from the company and add to params
            db.collection('customers').doc(customerId).collection('companyShortcuts').get()
            .then(snap => {
              snap.forEach(doc => {
                const data = doc.data();
                db.collection('customers').doc(customerId).collection('people').doc(user.uid).collection('shortcuts').add(data)
              })
            })
          }).catch(function(error) { console.log(error) });
        } else {
          console.log('account exists')
          // user already has an account: log in + add to database
          auth.signInWithEmailAndPassword(values.email, values.password)
          .then(res => {
            let user = firebase.auth().currentUser;
            params.uid = user.uid;
            db.collection('customers').doc(customerId).collection('people').doc(user.uid).set(params);
            // get the shortcuts from the company and add to params
            db.collection('customers').doc(customerId).collection('companyShortcuts').get()
            .then(snap => {
              snap.forEach(doc => {
                const data = doc.data();
                db.collection('customers').doc(customerId).collection('people').doc(user.uid).collection('shortcuts').add(data)
              })
            })
          }).catch(function(error) { console.log(error) });
        }
      })
      .then(result2 => {
        // remove all invites for this person
        db.collection('customers').doc(customerId).collection('invites').where('email', '==', values.email).get()
        .then(snap => {
          console.log('removing invites')
          snap.forEach(doc => {
            doc.ref.delete();
          });
        })
      })
      .then(result3 => {
        // redirect to homepage
        console.log('redirect?')
        setTimeout(() => {
          history.push('/' + customerId);
          window.location.reload();
        }, 3000);
      })

    } else { alert('The email address provided did not receive an invitation to register.'); }
  })

}

export const login = (user, custIdOverride) => (dispatch, getState) => {
  const customerId = custIdOverride || getState().general.company.customerId;
  if(customerId && user) {
    db.collection('customers').doc(customerId).collection('people').doc(user.uid).get()
    .then(doc => {
      if(doc.exists && doc.data().enabled) {
      // user exists for this company and is enabled
        dispatch({ type: UPDATE_USER, payload: doc.data() });
        dispatch({ type: SET_LOGGEDIN_USER_ID, payload: user.uid });
        dispatch(sync(`customers/${customerId}/people/${user.uid}`));
        dispatch(sync(`customers/${customerId}/people/${user.uid}/happiness`));
        dispatch(sync(`customers/${customerId}/people/${user.uid}/highFives`,  ref => ref.orderBy("date", "desc").limit(50)));
        dispatch(sync(`customers/${customerId}/people/${user.uid}/shortcuts`));
        if(doc.data().admin) {
          dispatch(sync(`customers/${customerId}/happinessComments`, ref => ref.orderBy("date", "desc").limit(50)))
          dispatch(sync(`customers/${customerId}/invites`));
          dispatch(sync(`customers/${customerId}/companyShortcuts`));
        };
      } else if(!doc.data().enabled) {
        alert('This account is disabled by the aministrator.')
      }
      // close overlay
      dispatch({ type: SET_OVERLAY, screen: 'login', action: false });
    })
    .catch(err => {console.log('error: ', err)})
  }
};
export const loggedOut = () => (dispatch, getState) => {
  dispatch({ type: SET_LOGGEDIN_USER_ID, payload: null });
}
export const logout = () => (dispatch, getState) => {
  dispatch({ type: SET_OVERLAY, screen: 'profile', state: false });
  auth.signOut()
};
export const updateProfile = values => (dispatch, getState) => {
  const uid = getState().general.user.uid;
  const customerId = getState().general.company.customerId;

  db.collection('customers').doc(customerId).collection('people').doc(uid).update(values);
}

export const startup = customerId => async (dispatch, getState) => {
  dispatch(sync(`quotes`));
  dispatch({type: VALIDATING_CUSTOMER});

  let customerRef = await db.collection('customers').doc(customerId).get();

  if(customerRef.exists){
    let customer = customerRef.data();
    let {location} = customer;
    dispatch({type: SET_CUSTOMER, payload: {customerId, info: customer }});
    dispatch({type: SET_CURRENT_CUSTOMER_ID, payload: customerId});


    auth.currentUser && db.collection('customers').doc(customerId).collection('people').doc(auth.currentUser.uid).onSnapshot(doc => {
      dispatch(login(auth.currentUser, customerId));
    });

    dispatch(sync(`customers/${customerId}`));
    dispatch(sync(`customers/${customerId}/airQualityData`, ref => ref.orderBy("time", "desc").limit(288)));

    setInterval(_ => dispatch({type: TIMER}), 1000);

    // listener average customer happiness
    db.collection('customers').doc(customerId).collection('happiness').doc(todayID).onSnapshot(doc => dispatch(getEmployeeHappiness(customerId)));

    // listener employees
    db.collection('customers').doc(customerId).collection('people').onSnapshot(doc => {
      dispatch(getAllEmployees(customerId));
      dispatch(getCompanyCubics(customerId));
    });

    let resp = await fetch(`${weather.baseUrl}?lat=${location.lat}&lon=${location.lng}&appid=${weather.apiKey}&units=metric`).then(r => r.json())
    let targetDate = moment(new Date()).add(1,'days').hour(12).unix();
    let closestEntry = resp && resp.list && resp.list.reduce(
      (acc, curr) => Math.abs(curr.dt - targetDate) < Math.abs(acc.dt - targetDate) ? curr : acc, {dt: 0}
    );
    let temperatureFloat = closestEntry.main && closestEntry.main.temp;
    let condition = closestEntry.weather && closestEntry.weather[0] && closestEntry.weather[0].id
    let humidity = closestEntry.main.humidity;
    let temperature = temperatureFloat && Math.round(temperatureFloat);

    if(temperature && condition && humidity){
      dispatch({type: SET_WEATHER, payload: {temperature, condition, humidity}});
    }else{
      dispatch({type: SET_WEATHER, payload: {temperature: null, condition: null, error: "There was an error fetching the weather info"}});
    }
  } else {
    dispatch({type: SET_CUSTOMER, payload: {customerId: null}});
  }
}

export const uploadPicture = file => (dispatch, getState) => {
  const uid = getState().general.user.uid;
  const customerId = getState().general.company.customerId;
  db.collection('customers').doc(customerId).collection('people').doc(uid).update({profilePic: 'loading'});

  firebase.storage().ref('userPictures/').child(customerId + '/' + uid).put(file)
  .then(snapshot => {
    firebase.storage().ref('userPictures/').child(customerId + '/' + uid).getDownloadURL().then(picUrl => {
      db.collection('customers').doc(customerId).collection('people').doc(uid).update({profilePic: picUrl});
    }).catch(function(error) {console.log(error) });
  }).catch(function(error) {console.log(error) });
}

export const getEmployeeHappiness = customerId => (dispatch, getState) => {
  // get average customer happiness
  db.collection('customers').doc(customerId).collection('happiness').doc(lastWeekID).get()
  .then(doc => {
    if(doc.exists) {
      dispatch({type: SET_EMPLOYEE_HAPPINESS, payload: doc.data().score });
    } else {
      // no entry done last week
      dispatch({type: SET_EMPLOYEE_HAPPINESS, payload: 8 });
    }
  })
}
export const getCompanyCubics = customerId => (dispatch, getState) => {
  // get all people to get there points
  db.collection('customers').doc(customerId).collection('people').get()
  .then(querySnapshot => {
    let i = 0;
    let companyCubics = 0;
    querySnapshot.forEach(doc => {
      if(doc.data().points) {
        companyCubics = companyCubics + doc.data().points;
      }
      i++
      if(i === querySnapshot.size) {
        dispatch({type: SET_CUSTOMER, payload: {companyCubics: companyCubics }});
      }
    });
  })
}
export const getAllEmployees = customerId => (dispatch, getState) => {
  db.collection('customers').doc(customerId).collection('people').get()
  .then(querySnapshot => {
    let allEmployees = [];
    let amount = querySnapshot.size;
    let i = 0;
    querySnapshot.forEach(doc => {
      // doc.data() is never undefined for query doc snapshots
      let data = doc.data();
      // name, for mention in highFive field
      data.name = data.nameF + ' ' + data.nameL;
      allEmployees.push(data)
      i++
      if(i === amount) {
        dispatch({type: UPDATE_EMPLOYEES, payload: allEmployees});
      }
    });
  })
  .catch(error => { console.log(error) })
}

export const emojiClicked = emojiScore => async (dispatch, getState) => {
  dispatch({ type: SET_MYHAPPINESS, label: 'score', payload: emojiScore });
}
export const myHappinessComment = value => (dispatch, getState) => {
  const { user } = getState().general;
  const { score } = todayHappiness(getState());
  const { customerId } = getState().general.company
  if(!value.todayHappiness) { value.todayHappiness = 'No comment added today' }
  db.collection('customers').doc(customerId).collection('people').doc(user.uid).collection('happiness').doc(todayID).set({score: score, comment: value.todayHappiness})
  db.collection('customers').doc(customerId).collection('happinessComments').add({
    comment: value.todayHappiness,
    date: moment().format("YYYY-MM-DD"),
    uid: user.uid
  })
  // recalculate company happiness this week
  db.collection('customers').doc(customerId).collection('happiness').doc(weekID).get()
  .then(doc => {
    if(!doc.exists) {
      // if first one to post today: add number
      db.collection('customers').doc(customerId).collection('happiness').doc(weekID).set({score: score});
    } else {
      // today is already added, calculate new average
      // get al people
      db.collection('customers').doc(customerId).collection('people').get()
        .then(querySnapshot => {
          let i = 0;
          let scoreTotal = 0;
          let amountResponses = 0;
          const amountPeople = querySnapshot.size;
          // go over people, get their happiness collection
          querySnapshot.forEach(doc => {
            db.collection('customers').doc(customerId).collection('people').doc(doc.id).collection('happiness').get()
            .then(querySnapshot2 => {
              // for every collection: go over all days to find matches
              querySnapshot2.forEach(doc => {
                daysInThisWeek.forEach(day => {
                  if(day === doc.id) {
                    scoreTotal = Number(scoreTotal) + Number(doc.data().score);
                    amountResponses++;
                  }
                })
              })
              i++;
              if(i === amountPeople ) {
                // devide average through amount of answers, round it
                const average = Math.round(scoreTotal / amountResponses);
                console.log(average)
                // save it on company level
                db.collection('customers').doc(customerId).collection('happiness').doc(weekID).set({score: average});
              }
            });
          })
        })
    }
  })
}

export const removeMyHappiness = _ => (dispatch, getState) => {
  let { loggedInUserId, currentCustomerId } = getState();

  dispatch({ type: LOAD_TODAYHAPPINESS, payload: null });
  db.doc(`customers/${currentCustomerId}/people/${loggedInUserId}/happiness/${todayID}`).delete();
  const today = moment().format("YYYY-MM-DD");
  db.collection('customers').doc(currentCustomerId).collection('happinessComments').where("date", "==", today).where("uid", "==", loggedInUserId).get()
  .then(snap => {
    console.log(snap);
    snap.forEach(doc => {
      db.collection('customers').doc(currentCustomerId).collection('happinessComments').doc(doc.id).delete()
    })
  })
  dispatch({ type: SET_OVERLAY, screen: 'profile', action: false });
}

export const highFiveAdded = (entityMap, message) => (dispatch, getState) => {
  const { uid } = getState().general.user;
  const customerId = getState().general.company.customerId;
  Object.keys(entityMap).forEach(key => {
    const receiverUid = entityMap[key].data.mention.uid;
    const now = moment().format("YYYY-MM-DD");
    db.collection('customers').doc(customerId).collection('people').doc(receiverUid).collection('highFives').doc().set({
      message: message,
      sender: uid,
      date: now,
      read: false
    });
    // recalculate score high fives
    db.collection('customers').doc(customerId).collection('people').doc(receiverUid).collection('highFives').get()
    // send email??
    .then(doc => {
      db.collection('customers').doc(customerId).collection('people').doc(receiverUid).update({points: doc.size});
    })
  });
}
export const updateShortcut = values => (dispatch, getState) => {
  const customerId = getState().general.company.customerId;
  const uid = getState().general.user.uid;
  if(getState().general.activeShortcut) {
    const shortcutId = getState().general.activeShortcut.id;
    db.collection('customers').doc(customerId).collection('people').doc(uid).collection('shortcuts').doc(shortcutId).update(values);
  } else {
    db.collection('customers').doc(customerId).collection('people').doc(uid).collection('shortcuts').add(values);
  }
  dispatch({ type: SET_OVERLAY, screen: 'shortcuts', action: false });
}
export const removeShortcut = e => (dispatch, getState) => {
  e.preventDefault()
  const customerId = getState().general.company.customerId;
  const uid = getState().general.user.uid;
  const shortcutId = getState().general.activeShortcut.id;
  db.collection('customers').doc(customerId).collection('people').doc(uid).collection('shortcuts').doc(shortcutId).delete()
  .catch(error => { console.error(error);
  });
  dispatch({ type: SET_OVERLAY, screen: 'shortcuts', action: false });
}
export const updateCompany = values => (dispatch, getState) => {
  const customerId = getState().general.company.customerId;
  db.collection('customers').doc(customerId).update({tagline: values.tagline})
  // for every shortcut: check if already set
  values.shortcuts.map(shortcut => {
    if(shortcut && shortcut.id) {
      db.collection('customers').doc(customerId).collection('companyShortcuts').doc(shortcut.id).get()
      .then(doc => {
        console.log('shortcut exists')
        db.collection('customers').doc(customerId).collection('companyShortcuts').doc(shortcut.id).update({
          link: shortcut.link,
          title: shortcut.title
        })
      })
    } else if(shortcut && shortcut.link) {
      db.collection('customers').doc(customerId).collection('companyShortcuts').add(shortcut)
    }
  })
  alert('Shortcuts are saved')
}
export const playClicked = () => (dispatch, getState) => {
  dispatch({ type: SET_OVERLAY, screen: 'video', action: true });
}
export const loginClicked = () => (dispatch, getState) => {
  dispatch({ type: SET_OVERLAY, screen: 'login', action: true });
}
export const shortcutClicked = values => (dispatch, getState) => {
  console.log(values)
  if(values !== null) {
    console.log(values)
    dispatch({ type: SET_ACTIVE_SHORTCUT, payload: values })
  } else {
    dispatch(reset('shortcutsForm'));
    dispatch({ type: SET_ACTIVE_SHORTCUT, payload: null })
  }
  dispatch({ type: SET_OVERLAY, screen: 'shortcuts', action: true });
}
export const profileClicked = () => (dispatch, getState) => {
  dispatch({ type: SET_OVERLAY, screen: 'profile', action: true });
}
export const presentClicked = () => (dispatch, getState) => {
  dispatch({ type: SET_OVERLAY, screen: 'highFives', action: true });

  const uid = getState().general.user.uid;
  const customerId = getState().general.company.customerId;
  console.log(customerId)
  console.log(uid)
  db.collection('customers').doc(customerId).collection('people').doc(uid).collection('highFives').get()
  .then(querySnapshot => {
    querySnapshot.forEach(doc => {
      let data = doc.id;
      setTimeout(() => {
        db.collection('customers').doc(customerId).collection('people').doc(uid).collection('highFives').doc(doc.id).update({read: true});
      }, 3000);
    });
  })
  .catch(error => { console.log(error) })
}
export const employeesClicked = () => (dispatch, getState) => {
  dispatch({ type: SET_OVERLAY, screen: 'employees', action: true });
}
export const followUpClicked = () => (dispatch, getState) => {
  dispatch({ type: SET_OVERLAY, screen: 'happinessFollowUp', action: true });
}
export const settingsClicked = () => (dispatch, getState) => {
  dispatch({ type: SET_OVERLAY, screen: 'settings', action: true });
}
export const profilePicClicked = state => (dispatch, getState) => {
  dispatch({ type: SET_OVERLAY, screen: 'profile', action: true });
}
export const employeeEnableClicked = employee =>  (dispatch, getState) => {
  const customerId = getState().general.company.customerId;
  if(employee.enabled === undefined) { employee.enabled = true }
  const newState = employee.enabled ? false : true;
  console.log('new: ', newState)
  db.collection('customers').doc(customerId).collection('people').doc(employee.uid).update({enabled: newState})
}
export const closeModal = (screen, state) => (dispatch, getState) => {
  dispatch({ type: SET_OVERLAY, screen: screen, action: false });
}
